import { executeTagging } from '../../../components/Tagging';
import { select, put, take } from 'redux-saga/effects';
import { ApplicationState } from '../..';
import { CustomersState } from '../../../store/ducks/customers/types';
import { IUserState } from '../../../store/ducks/user/types';
import { TaggingParams } from '../../../components/Tagging/TaggingParams';
import { Types } from './types';
import { Types as CustomerTypes } from '../../ducks/customers/types';
import { sendTaggingFailure, sendTaggingSuccess } from './actions';

interface ITaggingParams {
  payload: TaggingParams;
  type: Types;
}

export function* sendTaggingSaga(params: ITaggingParams) {
  try {
    const userState: IUserState = yield select(
      (state: ApplicationState) => state.user
    );
    let customersState: CustomersState = yield select(
      (state: ApplicationState) => state.customers
    );

    if (customersState.loading) {
      yield take(CustomerTypes.LOAD_CUSTOMERS_SUCCESS);

      customersState = yield select(
        (state: ApplicationState) => state.customers
      );
    }

    yield executeTagging({ ...params.payload, userState, customersState });
    yield put(sendTaggingSuccess(params.payload));
  } catch (err) {
    console.error('sendTaggingSaga', err);
    yield put(sendTaggingFailure(err));
  }
}
